import * as React from 'react';

interface IProps {
    className?: string;
}

class IconEllipseTopLeft extends React.Component<IProps> {
    public render() {
        return (
            <svg width="233" height="287" viewBox="0 0 233 287" fill="none" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
                <circle cx="4" cy="58" r="204" stroke="#039BE5" strokeWidth="50" />
            </svg>
        );
    }
}

export default IconEllipseTopLeft;
